
export const validValues = {
    EDIT: "1"
    , VIEW: "2"
}

export const profile = {
    Clients: {
        displayName: "Clientes"
        , validValues: [validValues.EDIT, validValues.VIEW]
        , fields: {
            ADD: { displayName: "Criar Cliente", validValues: [validValues.EDIT] }
            , DEL: { displayName: "Eliminar Cliente", validValues: [validValues.EDIT] }
            , isActive: { displayName: "Activar Cliente", validValues: [validValues.EDIT, validValues.VIEW] }
            , canPrint: { displayName: "Imprimir Cliente", validValues: [validValues.VIEW] }
            , clientHistory: { displayName: "Historial Clínico", validValues: [validValues.EDIT, validValues.VIEW] }
            , globalNotes: { displayName: "Notas Globais", validValues: [validValues.EDIT, validValues.VIEW] }
            , clientServices: { displayName: "Serviços de Cliente", validValues: [validValues.EDIT, validValues.VIEW] }
            , clientServicesADD: { displayName: "Criar Serviços de Cliente", validValues: [validValues.EDIT] }
            , clientServicesDEL: { displayName: "Eliminar Serviços de Cliente", validValues: [validValues.EDIT] }
        }
    }
    , Appointments: {
        displayName: "Marcações"
        , validValues: [validValues.EDIT, validValues.VIEW]
        , fields: {
            ADD: { displayName: "Criar Marcações", validValues: [validValues.EDIT] }
            , DEL: { displayName: "Eliminar Marcações", validValues: [validValues.EDIT] }
            , isActive: { displayName: "Activar Marcações", validValues: [validValues.EDIT, validValues.VIEW] }
        }
    }
    , Staff: {
        displayName: "Funcionários"
        , validValues: [validValues.EDIT, validValues.VIEW]
        , subPages: ["Schedules"]
        , fields: {
            ADD: { displayName: "Criar Funcionários", validValues: [validValues.EDIT] }
            , DEL: { displayName: "Eliminar Funcionários", validValues: [validValues.EDIT] }
            , isActive: { displayName: "Activar Funcionários", validValues: [validValues.EDIT, validValues.VIEW] }
        }
    }
    , Schedules: {
        displayName: "Horários"
        , validValues: [validValues.EDIT, validValues.VIEW]
        , isSubPage: true
        , fields: {
            handleBreaks: { displayName: "Gerir Pausas", validValues: [validValues.EDIT, validValues.VIEW] }
            , handleHolidays: { displayName: "Gerir Folgas", validValues: [validValues.EDIT, validValues.VIEW] }
            , seeTotals: { displayName: "Totais", validValues: [validValues.VIEW] }
            , seePast: { displayName: "Horário Passado", validValues: [validValues.VIEW] }
            , seeFuture: { displayName: "Horário Futuro", validValues: [validValues.VIEW] }
            , canPrintSchedule: { displayName: "Imprimir Horário", validValues: [validValues.VIEW] }
        }
    }
    , Services: {
        displayName: "Serviços"
        , validValues: [validValues.EDIT, validValues.VIEW]
        , fields: {
            ADD: { displayName: "Criar Serviços", validValues: [validValues.EDIT] }
            , DEL: { displayName: "Eliminar Serviços", validValues: [validValues.EDIT] }
            , isActive: { displayName: "Activar Serviços", validValues: [validValues.EDIT, validValues.VIEW] }
        }
    }
    , Products: {
        displayName: "Produtos"
        , validValues: [validValues.EDIT, validValues.VIEW]
        , subPages: ["Suppliers"]
        , fields: {
            ADD: { displayName: "Criar Produtos", validValues: [validValues.EDIT] }
            , DEL: { displayName: "Eliminar Produtos", validValues: [validValues.EDIT] }
            , isActive: { displayName: "Activar Produtos", validValues: [validValues.EDIT, validValues.VIEW] }
            , cost: { displayName: "Custo Produto", validValues: [validValues.EDIT, validValues.VIEW] }
            , price: { displayName: "Preço Produto", validValues: [validValues.EDIT, validValues.VIEW] }
        }
    }
    , Suppliers: {
        displayName: "Fornecedores"
        , isSubPage: true
        , validValues: [validValues.EDIT, validValues.VIEW]
        , fields: {
            ADD: { displayName: "Criar Fornecedores", validValues: [validValues.EDIT] }
            , DEL: { displayName: "Eliminar Fornecedores", validValues: [validValues.EDIT] }
            , isActive: { displayName: "Activar Fornecedores", validValues: [validValues.EDIT, validValues.VIEW] }
        }
    }
    , Stores: {
        displayName: "Lojas"
        , validValues: [validValues.EDIT, validValues.VIEW]
        , subPages: ["StoreStock"]
        , fields: {
            ADD: { displayName: "Criar Lojas", validValues: [validValues.EDIT] }
            , DEL: { displayName: "Eliminar Lojas", validValues: [validValues.EDIT] }
            , isActive: { displayName: "Activar Lojas", validValues: [validValues.EDIT, validValues.VIEW] }
        }
    }
    , StoreStock: {
        displayName: "Inventário"
        , validValues: [validValues.EDIT, validValues.VIEW]
        , isSubPage: true
        , fields: {}
    }
    , Communications: {
        displayName: "Comunicações"
        , validValues: [validValues.EDIT, validValues.VIEW]
        , fields: {
            ADD: { displayName: "Criar Comunicações", validValues: [validValues.EDIT] }
            , DEL: { displayName: "Eliminar Comunicações", validValues: [validValues.EDIT] }
            , isActive: { displayName: "Activar Comunicações", validValues: [validValues.EDIT, validValues.VIEW] }
        }
    }
    , Users: {
        displayName: "Utilizadores"
        , validValues: [validValues.EDIT, validValues.VIEW]
        , fields: {
            ADD: { displayName: "Criar Utilizadores", validValues: [validValues.EDIT] }
            , DEL: { displayName: "Eliminar Utilizadores", validValues: [validValues.EDIT] }
            , isActive: { displayName: "Activar Utilizadores", validValues: [validValues.EDIT, validValues.VIEW] }
            , passwordInput: { displayName: "Palavra-passe", validValues: [validValues.EDIT, validValues.VIEW] }
            , secretQuestion: { displayName: "Pergunta secreta", validValues: [validValues.EDIT, validValues.VIEW] }
            , accessLevels: { displayName: "Nível de utilizador", validValues: [validValues.EDIT, validValues.VIEW] }
        }
    }
    , Cart: {
        displayName: "Carrinho"
        , validValues: [validValues.EDIT, validValues.VIEW]
        , fields: {
            ADD: { displayName: "Criar", validValues: [validValues.EDIT] }
            , DEL: { displayName: "Cancelar", validValues: [validValues.EDIT] }
            , viewAllOrders: { displayName: "Ver todas as compras", validValues: [validValues.VIEW] }
            , canPrint: { displayName: "Pode Imprimir", validValues: [validValues.VIEW] }
        }
    }
    , Payments: {
        displayName: "Pagamentos"
        , validValues: [validValues.EDIT, validValues.VIEW]
        , fields: {
            ADD: { displayName: "Criar", validValues: [validValues.EDIT] }
            , DEL: { displayName: "Eliminar", validValues: [validValues.EDIT] }
            , updatePayments: { displayName: "Editar pagamentos", validValues: [validValues.EDIT] }
            , viewTotals: { displayName: "Ver totais", validValues: [validValues.VIEW] }
            , viewAllPayments: { displayName: "Ver todos os pagamentos", validValues: [validValues.VIEW] }
            , filters: { displayName: "Filtrar", validValues: [validValues.EDIT] }
        }
    }
    , Settings: {
        displayName: "Definições"
        , validValues: [validValues.EDIT, validValues.VIEW]
        , fields: {
            ADD: { displayName: "Criar", validValues: [validValues.EDIT] }
            , DEL: { displayName: "Eliminar", validValues: [validValues.EDIT] }
            , holidayReasons: { displayName: "Justificações de Falta", validValues: [validValues.EDIT, validValues.VIEW] }
            , paymentConditions: { displayName: "Condições de Pagamentos", validValues: [validValues.EDIT, validValues.VIEW] }
            , sellers: { displayName: "Vendedores", validValues: [validValues.EDIT, validValues.VIEW] }
            , jobTypes: { displayName: "Cargos de Funcionários", validValues: [validValues.EDIT, validValues.VIEW] }
        }
    }
    , Segmentation: {
        displayName: "Segmentação"
        , validValues: [validValues.EDIT, validValues.VIEW]
        , fields: {
            ADD: { displayName: "Criar", validValues: [validValues.EDIT] }
            , DEL: { displayName: "Eliminar", validValues: [validValues.EDIT] }
            , isActive: { displayName: "Activar Lista", validValues: [validValues.EDIT, validValues.VIEW] }
        }
    }
    , Notepad: {
        displayName: "Bloco de Notas"
        , validValues: [validValues.EDIT, validValues.VIEW]
        , fields: {
            ADD: { displayName: "Criar", validValues: [validValues.EDIT] }
            , DEL: { displayName: "Eliminar", validValues: [validValues.EDIT] }
            , isActive: { displayName: "Activar Lista", validValues: [validValues.EDIT, validValues.VIEW] }
        }
    }
};
